module.exports = __webpack_public_path__ + "images/369bbfab85d4ca03bc263b7ea7fd6173-trendingImg6.png";